import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import { ResponsiveImage } from '../index';
import css from './HeroSection.module.css';

// Cap mobile at 600px so browser picks scaled600 instead of 1200 on retina
const HERO_VARIANTS = ['scaled600', 'scaled1200'];
const HERO_SIZES = '(max-width: 768px) 100vw, 50vw';

const HeroSection = ({ section, imageProps }) => {
  const history = useHistory();
  const { appearance, callToAction, description, title } = section || {};
  const backgroundImage = appearance?.backgroundImage;
  const lcpImageUrl =
    (imageProps && backgroundImage?.attributes?.variants?.scaled600?.url) ||
    backgroundImage?.attributes?.variants?.scaled1200?.url;

  return (
    <div className={css.container}>
      {lcpImageUrl && (
        <Helmet>
          <link rel="preload" href={lcpImageUrl} as="image" />
        </Helmet>
      )}
      {backgroundImage?.attributes?.variants && (
        <ResponsiveImage
          alt={title?.content || 'Hero image'}
          image={backgroundImage}
          variants={HERO_VARIANTS}
          sizes={HERO_SIZES}
          {...imageProps}
        />
      )}
      <div className={css.sideSection}>
        <h1>{title.content}</h1>
        <p>{description.content}</p>
        <span onClick={() => history.push(callToAction.href)}>{callToAction.content}</span>
      </div>
    </div>
  );
};

export default HeroSection;
